module.exports = __webpack_public_path__ + "line.567f57385ea3dde2c9ae.gif";


//////////////////
// WEBPACK FOOTER
// /var/www/delios/delios-live/app/node_modules/primeng/resources/images/line.gif
// module id = ../../../../primeng/resources/images/line.gif
// module chunks = styles